export default __webpack_public_path__ + "static/media/violet-arrow-right.5a6b43f9.svg";